import ReactJS from "../pages/Helpers/ReactJS";
import ReactNative from "../pages/Helpers/ReactNative";

export const HelpersRoutes = [
  { path: "/reactjs", name: "ReactJS", component: ReactJS },
  { path: "/react-native", name: "ReactNative", component: ReactNative },
];
